import { connect } from 'react-redux'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'
import ProductListViewPullSellersProductsToSalePage from './ProductListViewPullSellersProductsToSalePage'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewPullSellersProductsToSalePage)
